import { FetchError } from '@/connection/helpers';
import toastTrigger from '@ui/toast/toast-trigger';

const handleImageUploadErrors = (error: unknown, errorMessage?: string) => {
  let _errorMessage = errorMessage || 'Error saving image';
  if (error instanceof FetchError) {
    if (error.response.status === 429) {
      _errorMessage = 'Too many requests, please wait a few seconds and try again.';
    }
  }
  toastTrigger(
    <div>
      <div className="S2">{_errorMessage}</div>
    </div>,
    {
      type: 'error',
      closeButton: false,
      closeOnClick: false,
      autoClose: 12000, // we rate limit for 12 seconds in the api, so setting this timeout to that duration
    }
  );
};

export default handleImageUploadErrors;
